// ============================================================
// web/src/features/apprentissage/ChampsCorriges.jsx — où le programme se
// trompe le plus, croisé avec le client émetteur du plan.
// Sorti d'`ApprentissagePage` le 15 septembre 2026 pour faire la place de
// la surveillance de l'apprentissage, sans desserrer le plafond de lignes.
// ============================================================
import { Card, CardHead, CardBody } from '../../ui/Card.jsx';
import Table from '../../ui/Table.jsx';
import Badge from '../../ui/Badge.jsx';

export function ChampsCorriges({ champs }) {
  return (
    <Card>
      <CardHead title="Où le programme se trompe le plus" />
      <CardBody className="stack">
        <p className="field__hint">
          Croisé avec le client émetteur du plan. C’est ce croisement qui fait la différence
          entre une <em>convention d’écriture</em> propre à un donneur d’ordre — qui se corrige
          par un alias, une fois pour toutes — et une faiblesse générale de lecture, qui ne se
          corrige pas comme ça.
        </p>
        <Table
          caption="Champs les plus corrigés"
          columns={[
            { key: 'field', label: 'Champ' },
            {
              key: 'agent',
              label: 'Nature',
              render: (r) => (
                <Badge tone={r.agent === 'derivation' ? 'ok' : 'neutral'}>
                  {r.agent === 'derivation' ? 'jugement' : 'perception'}
                </Badge>
              ),
            },
            { key: 'client', label: 'Client émetteur', render: (r) => r.client ?? '—' },
            { key: 'corrections', label: 'Corrections' },
          ]}
          rows={champs}
          getRowKey={(r) => `${r.field}-${r.client_id ?? 0}`}
        />
      </CardBody>
    </Card>
  );
}

export default ChampsCorriges;
